var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  class: {
                    "active-filter-card": _vm.activeFilter === "Pending"
                  },
                  staticStyle: { cursor: "pointer" },
                  attrs: { outlined: "" },
                  on: {
                    click: function($event) {
                      return _vm.filterByStatus("Pending")
                    }
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-2" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "orange darken-2", left: "" } },
                            [_vm._v("mdi-clock-outline")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "subtitle-2 orange--text text--darken-2"
                            },
                            [_vm._v(_vm._s(_vm.$t("kelaBatch.summaryPending")))]
                          ),
                          _c("v-spacer"),
                          _vm.activeFilter === "Pending"
                            ? _c(
                                "v-icon",
                                { attrs: { small: "", color: "primary" } },
                                [_vm._v("mdi-filter")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.summaryLoading
                        ? [
                            _c("v-skeleton-loader", {
                              attrs: { type: "text", width: "120" }
                            }),
                            _c("v-skeleton-loader", {
                              staticClass: "mt-1",
                              attrs: { type: "text", width: "160" }
                            })
                          ]
                        : _vm.summary
                        ? [
                            _c(
                              "div",
                              { staticClass: "text-h5 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.summary.pendingFeedback.batchCount
                                  ) +
                                    " " +
                                    _vm._s(_vm.$t("kelaBatch.batches"))
                                )
                              ]
                            ),
                            _c("div", { staticClass: "body-2 grey--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.summary.pendingFeedback
                                    .transportEventCount
                                ) +
                                  " " +
                                  _vm._s(_vm.$t("kelaBatch.events"))
                              )
                            ]),
                            _c("div", { staticClass: "body-1 mt-1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatCurrency(
                                    _vm.summary.pendingFeedback
                                      .totalReimbursement
                                  )
                                )
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  class: { "active-filter-card": _vm.activeFilter === "OK" },
                  staticStyle: { cursor: "pointer" },
                  attrs: { outlined: "" },
                  on: {
                    click: function($event) {
                      return _vm.filterByStatus("OK")
                    }
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-2" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "green darken-2", left: "" } },
                            [_vm._v("mdi-check-circle-outline")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "subtitle-2 green--text text--darken-2"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("kelaBatch.summaryProcessed"))
                              )
                            ]
                          ),
                          _c("v-spacer"),
                          _vm.activeFilter === "OK"
                            ? _c(
                                "v-icon",
                                { attrs: { small: "", color: "primary" } },
                                [_vm._v("mdi-filter")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.summaryLoading
                        ? [
                            _c("v-skeleton-loader", {
                              attrs: { type: "text", width: "120" }
                            }),
                            _c("v-skeleton-loader", {
                              staticClass: "mt-1",
                              attrs: { type: "text", width: "160" }
                            })
                          ]
                        : _vm.summary
                        ? [
                            _c(
                              "div",
                              { staticClass: "text-h5 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.summary.processed.batchCount) +
                                    " " +
                                    _vm._s(_vm.$t("kelaBatch.batches"))
                                )
                              ]
                            ),
                            _c("div", { staticClass: "body-2 grey--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.summary.processed.transportEventCount
                                ) +
                                  " " +
                                  _vm._s(_vm.$t("kelaBatch.events"))
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-card",
                {
                  class: { "active-filter-card": _vm.activeFilter === "Error" },
                  staticStyle: { cursor: "pointer" },
                  attrs: { outlined: "" },
                  on: {
                    click: function($event) {
                      return _vm.filterByStatus("Error")
                    }
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center mb-2" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "red darken-2", left: "" } },
                            [_vm._v("mdi-alert-circle-outline")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "subtitle-2 red--text text--darken-2"
                            },
                            [_vm._v(_vm._s(_vm.$t("kelaBatch.summaryError")))]
                          ),
                          _c("v-spacer"),
                          _vm.activeFilter === "Error"
                            ? _c(
                                "v-icon",
                                { attrs: { small: "", color: "primary" } },
                                [_vm._v("mdi-filter")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.summaryLoading
                        ? [
                            _c("v-skeleton-loader", {
                              attrs: { type: "text", width: "120" }
                            }),
                            _c("v-skeleton-loader", {
                              staticClass: "mt-1",
                              attrs: { type: "text", width: "160" }
                            })
                          ]
                        : _vm.summary
                        ? [
                            _c(
                              "div",
                              { staticClass: "text-h5 font-weight-bold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.summary.error.batchCount) +
                                    " " +
                                    _vm._s(_vm.$t("kelaBatch.batches"))
                                )
                              ]
                            ),
                            _c("div", { staticClass: "body-2 grey--text" }, [
                              _vm._v(
                                _vm._s(_vm.summary.error.transportEventCount) +
                                  " " +
                                  _vm._s(_vm.$t("kelaBatch.events"))
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { attrs: { outlined: "" } },
                [
                  _c("v-card-title", { staticClass: "subtitle-1" }, [
                    _vm._v(_vm._s(_vm.$t("kelaBatch.monthlyChart")))
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _vm.summaryLoading
                        ? _c("v-skeleton-loader", { attrs: { type: "image" } })
                        : _vm.summary &&
                          _vm.summary.monthlyProcessed &&
                          _vm.summary.monthlyProcessed.length > 0
                        ? _c("bar-chart", {
                            style: { height: "280px" },
                            attrs: {
                              "chart-data": _vm.barChartData,
                              options: _vm.barChartOptions
                            }
                          })
                        : _c(
                            "div",
                            { staticClass: "grey--text text-center py-8" },
                            [_vm._v("-")]
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }